import {HINTS_STR} from './hints';
const listeners = [];

// listeners.push(location => {
//   window.gtag('config', 'G-CFV5HE2PEC', { page_path:'' ,product: 'PP'})
// })

export let LOCATION = updateLocation();

export function navigate(location) {
  history.pushState({}, document.title, location + (HINTS_STR ? '?' + HINTS_STR : ''));
  updateNavigation();
}

export function navigateWithData(location, data) {
  history.pushState({data}, document.title, location + (HINTS_STR ? '?' + HINTS_STR : ''));
  updateNavigation();
}

export function toAbsPath(path, ctx) {
  const abs = path.startsWith('/');
  return abs ? path : '/' + ctx.consumedPath.join('/') + '/' + path;
}


function updateNavigation(forceUpdate) {
  LOCATION = updateLocation();
  listeners.forEach(l => l(LOCATION));
}

export function addNavigationListener(listener) {
  const index = listeners.length;
  listeners.push(listener);
  return () => listeners.splice(index, 1);
}

window.onpopstate = function() {
  updateNavigation();
};

function updateLocation() {
  return {
    path: document.location.pathname,
    queryParams: {} //document.location.search ? Object.fromEntries(new URLSearchParams(document.location.search.substring(1))) : {};
  }
}

export function navigateToHome() {
  if (__LANDING_PAGE_URL__){
    window.location.assign(__LANDING_PAGE_URL__);
  }else {
    navigate('/');
  }
}